/**
 * Lazily loads the Google Picker JS API (apis.google.com/js/api.js + the
 * 'picker' module) and resolves once window.google.picker is available.
 *
 * The promise is cached so repeated "Import from Drive" clicks don't re-inject
 * the script; on failure the cache is cleared so a later attempt can retry.
 */
let pickerPromise = null

export function loadGooglePicker() {
  if (window.google && window.google.picker) return Promise.resolve()
  if (pickerPromise) return pickerPromise

  pickerPromise = new Promise((resolve, reject) => {
    const loadPickerModule = () => {
      if (!window.gapi) {
        reject(new Error('Google API (gapi) failed to load'))
        return
      }
      window.gapi.load('picker', {
        callback: () => resolve(),
        onerror: () => reject(new Error('Failed to load the Google Picker module')),
      })
    }

    const existing = document.getElementById('google-api-js')
    if (existing) {
      if (window.gapi) loadPickerModule()
      else existing.addEventListener('load', loadPickerModule, { once: true })
      return
    }

    const script = document.createElement('script')
    script.id = 'google-api-js'
    script.src = 'https://apis.google.com/js/api.js'
    script.async = true
    script.defer = true
    script.onload = loadPickerModule
    script.onerror = () => reject(new Error('Failed to load the Google API script'))
    document.body.appendChild(script)
  })

  pickerPromise.catch(() => { pickerPromise = null })
  return pickerPromise
}
